import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { interpreterSelector } from 'slices/interpreterSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInterpreters } from 'slices/interpreterSlice';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { Select } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import moment from 'moment';
import { actionButtonsSelector } from 'slices/actionButtonSlice';
import { useTranslation } from 'react-i18next';

export const CheckinCheckoutAdjustmentModal = ({ item, onSubmit, handleClose, onClose,isOpen, targetTimezone  }) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const commentOptions = [
        { label: t("checkinAdjustment.admissionIntake"), value: "Admission/Intake" },
        { label: t("checkinAdjustment.discharge"), value: "Discharge" },
        { label: t("checkinAdjustment.informedConsent"), value: "Informed Consent" },
        { label: t("checkinAdjustment.serviceDecline"), value: "Service Decline" },
        { label: t("checkinAdjustment.other"), value: "Other" }
    ];

    // isOpen change hone par animation trigger karo
    useEffect(() => {
        if (isOpen) {
            // next tick mein open karo taake browser transition pakad sake
            requestAnimationFrame(() => setVisible(true));
        } else {
            setVisible(false);
        }
    }, [isOpen]);
    
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [scheduleItem, setScheduleItem] = useState({})
    const methods = useForm({
        defaultValues: {
            options: "current_time",
            checkin_date: moment().format("YYYY-MM-DD"),
            checkin_time: moment().format("HH:mm"),
            checkout_date: moment().format("YYYY-MM-DD"),
            checkout_time: moment().add(15).format("HH:mm"),
        }

    });
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, reset } = methods

    const handleCloseScheduleForm = () => {
        setLoader(false);
        reset();
        localStorage.removeItem("selected_schedule_item");
        shutDownModal();
    };
    
    const shutDownModal = () => {
        setVisible(false);
        setTimeout(() => {
            onClose && onClose();
            handleClose && handleClose();
        }, 250);
    };

    // useEffect(()=>{
    //     setValue('checkin_date', item?.appointment_assign?.checkin_date || moment().format("YYYY-MM-DD"))
    //     setValue('checkin_time', item?.appointment_assign?.checkin_time || moment().format("HH:mm"))
    //     setValue('checkout_date', item?.appointment_assign?.checkout_date || moment().format("YYYY-MM-DD"))
    //     setValue('checkout_time', item?.appointment_assign?.checkout_time || moment().format("HH:mm"))
    //     setValue('comments', item?.appointment_assign?.comments || '')
    //     setValue('notes', item?.appointment_assign?.notes || '')
    // },[item])

    useEffect(() => {

        // const appointmentTz = item?.appointment_details?.timezone?.name;
        // const scheduledMoment = item?.datetime
        //     ? (appointmentTz ? moment.tz(item.datetime, appointmentTz) : moment(item.datetime))
        //     : null;

        // const checkinDate = item?.appointment_assign?.checkin_date
        //     || (scheduledMoment ? scheduledMoment.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
        // const checkinTime = item?.appointment_assign?.checkin_time
        //     || (scheduledMoment ? scheduledMoment.format("HH:mm") : moment().format("HH:mm"));

        const appointmentTz = item?.appointment_details?.timezone?.name;

        const sourceMoment = item?.datetime
            ? (appointmentTz ? moment.tz(item.datetime, appointmentTz) : moment.utc(item.datetime))
            : null;

        const scheduledMoment = sourceMoment
            ? (targetTimezone ? sourceMoment.clone().tz(targetTimezone) : sourceMoment)
            : null;

        const checkinDate = item?.appointment_assign?.checkin_date
            || (scheduledMoment ? scheduledMoment.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
        const checkinTime = item?.appointment_assign?.checkin_time
            || (scheduledMoment ? scheduledMoment.format("HH:mm") : moment().format("HH:mm"));

        // const checkinDate = item?.appointment_assign?.checkin_date || moment().format("YYYY-MM-DD");
        // const checkinTime = item?.appointment_assign?.checkin_time || moment().format("HH:mm");

        setValue('checkin_date', checkinDate);
        setValue('checkin_time', checkinTime);

        const checkoutDate = item?.appointment_assign?.checkout_date;
        const checkoutTime = item?.appointment_assign?.checkout_time;

        if (checkoutDate && checkoutTime) {
            setValue('checkout_date', checkoutDate);
            setValue('checkout_time', checkoutTime);
        } else {
            const duration = item?.estimated_duration || 0;
            const unit = item?.estimated_duration_unit || 'minute';

            const checkoutMoment = moment(
                `${checkinDate} ${checkinTime}`,
                "YYYY-MM-DD HH:mm"
            ).add(duration, unit === 'hour' ? 'hours' : 'minutes');

            setValue('checkout_date', checkoutMoment.format("YYYY-MM-DD"));
            setValue('checkout_time', checkoutMoment.format("HH:mm:00"));
        }

        setValue('comments', item?.appointment_assign?.comments || '');
        setValue('notes', item?.appointment_assign?.notes || '');
    }, [isOpen, item]);
    if (!isOpen) return null;
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: visible ? 1 : 0,
            transition: 'opacity 0.25s ease',
        }}
        onClick={(e) => {
            if (e.target === e.currentTarget) handleCloseScheduleForm();
        }}>
            <div style={{width: '100%', maxWidth: '800px', margin: '0 16px', borderRadius: '40px', padding: '2rem', background: '#fff', transform: visible ? 'scale(1) translateY(0)' : 'scale(0.92) translateY(16px)', opacity: visible ? 1 : 0, transition: 'transform 0.25s ease, opacity 0.25s ease',}}>
                <div className="modal-content full_modal">
                    <div className="modal-header header_modal align-items-center">
                        <div></div>
                        <h5 className="modal-title_u">{t("checkinAdjustment.title")}</h5>
                        <button type="button" onClick={handleCloseScheduleForm} className="btn-close" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className='row-primary flex-column gap-0 mb-3'>
                            <h2 className='fst-italic mb-2'>{t("checkinAdjustment.checkIn")}</h2>
                            <div className='row-primary row-r'>
                                <div className="date">
                                    <h2>{t("checkinAdjustment.date")}</h2>
                                    <Controller
                                        name="checkin_date"
                                        control={control}
                                        rules={{
                                            required: t("checkinAdjustment.selectDate")
                                        }}
                                        render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <div className="input-image">
                                                <input id='date' type="date" name='checkin_date' placeholder='YYYY-MM-DD' required
                                                    {...field}
                                                    value={field.value ? moment(field.value).format('YYYY-MM-DD') : ""}
                                                    onChange={(e) => {
                                                        const dateString = moment.utc(e.target.value).format('YYYY-MM-DD')
                                                        field.onChange(dateString)
                                                    }}
                                                />
                                                <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />
                                            </div>
                                            {errors?.checkin_date?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.checkin_date?.message} />
                                                </div>
                                            }
                                        </div>
                                        }/>
                                </div>

                                <div className="time">
                                    <h2>{t("checkinAdjustment.time")}</h2>
                                    <Controller
                                        name="checkin_time"
                                        control={control}
                                        rules={{
                                            required: t("checkinAdjustment.selectTime")
                                        }}
                                        render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <div className="input-image">
                                                <input id='checkin_time' type="time" name='checkin_time'
                                                    placeholder='HH:MM:SS' required
                                                    {...field}
                                                    value={field.value ? moment(field.value, ["h:mm A"]).format("HH:mm") : ""}
                                                    onChange={(e) => {
                                                        const timeString = moment(new Date()).set({ hour: parseInt(e.target.value.slice(0, 2)), minute: parseInt(e.target.value.slice(3, 5)) }).format('HH:mm:00')
                                                        field.onChange(timeString)
                                                    }}
                                                />
                                                <img src="/images/clock.png" alt="celender Icon" className="custom-icon" />
                                                {errors?.checkin_time?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.checkin_time?.message} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        }/>
                                </div>
                            </div>
                        </div>

                        <div className='row-primary flex-column gap-0 mb-3'>
                            <h2 className='fst-italic mb-2'>{t("checkinAdjustment.checkOut")}</h2>
                            <div className='row-primary row-r'>
                                <div className="date">
                                    <h2>{t("checkinAdjustment.date")}</h2>
                                    <Controller
                                        name="checkout_date"
                                        control={control}
                                        rules={{
                                            required: t("checkinAdjustment.selectDate")
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input id='checkout_date' type="date" name='checkout_date'
                                                        placeholder='YYYY-MM-DD' required
                                                        {...field}
                                                        value={field.value ? moment(field.value).format('YYYY-MM-DD') : ""}
                                                        onChange={(e) => {
                                                            const dateString = moment.utc(e.target.value).format('YYYY-MM-DD')
                                                            field.onChange(dateString)
                                                        }}
                                                    />
                                                    <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

                                                </div>
                                                {errors?.checkout_date?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.checkout_date?.message} />
                                                    </div>
                                                }
                                            </div>
                                        } />
                                </div>

                                <div className="time">
                                    <h2>{t("checkinAdjustment.time")}</h2>
                                    <Controller
                                        name="checkout_time"
                                        control={control}
                                        rules={{
                                            required: t("checkinAdjustment.selectTime")
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input id='checkout_time' type="time" name='checkout_time'
                                                        placeholder='HH:MM:SS' required
                                                        {...field}
                                                        value={field.value ? moment(field.value, ["h:mm A"]).format("HH:mm") : ""}
                                                        onChange={(e) => {
                                                            const timeString = moment(new Date()).set({ hour: parseInt(e.target.value.slice(0, 2)), minute: parseInt(e.target.value.slice(3, 5)) }).format('HH:mm:00')
                                                            field.onChange(timeString)
                                                        }}
                                                    />
                                                    <img src="/images/clock.png" alt="celender Icon" className="custom-icon" />
                                                    {errors?.checkout_time?.message &&
                                                        <div style={{ marginBottom: 10 }}>
                                                            <ErrorMessage text={errors?.checkout_time?.message} />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    />

                                </div>
                            </div>
                        </div>

                        {/* Comments */}
                        <div className="row-primary mb-3">
                            <h2>{t("checkinAdjustment.comments")}</h2>
                            <Controller
                                name="comments"
                                control={control}
                                rules={{
                                    required: t("checkinAdjustment.selectComment")
                                }}
                                render={({ field }) =>
                                    <div style={{ width: "100%" }}>
                                        <Select
                                            name="comments"
                                            options={commentOptions || []}
                                            value={field.value ? commentOptions?.find((opt) => field.value == opt.value) : ""}
                                            isClearable={false}
                                            disabledSearch={true}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}


                                        />

                                        {errors?.comments?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.comments?.message} />
                                            </div>
                                        }

                                    </div>
                                }
                            />
                        </div>

                        <div className="row-primary mb-3">
                            <h2>{t("checkinAdjustment.notes")}</h2>
                            <Controller
                                name="notes"
                                control={control}
                                render={({ field }) =>
                                    <textarea
                                        className="type_inp input-in"
                                        {...field}
                                        placeholder={t("checkinAdjustment.notesPlaceholder")}
                                    >
                                    </textarea>
                                }

                            />
                        </div>

                        <div className="modal-body">
                            <SubmitButton
                                className="me-auto"
                                btnText={t("translation.submit")}
                                buttonType="button"
                                loader={loader}
                                handleSubmit={handleSubmit((data) => {
                                    setLoader(true)
                                    onSubmit(data, "adjustment", handleCloseScheduleForm);
                                })}>
                                {t("checkinAdjustment.submitRequest")}
                            </SubmitButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
